import { ref } from 'vue';
import Compressor from 'compressorjs';

export function useImageCompressor() {
  const isCompressing = ref(false);
  const error = ref<string | null>(null);

  const compressImage = async (file: File): Promise<File | null> => {
    if (isCompressing.value) return null;

    isCompressing.value = true;
    error.value = null;

    return new Promise<File | null>((resolve, reject) => {
      new Compressor(file, {
        quality: 0.8, // Sıkıştırma kalitesini belirleyin (0-1 arası) 
        maxWidth: 1024,
        maxHeight: 1024,
        success(result) {
          // Blob'dan File'a dönüşüm
          const compressedFile = new File([result as Blob], file.name, {
            type: file.type,
            lastModified: Date.now(),
          });
          isCompressing.value = false;
          resolve(compressedFile);
        },
        error(err) {
          error.value = err.message;
          isCompressing.value = false;
          reject(err);
        }
      });
    });
  };

  return {
    isCompressing,
    error,
    compressImage
  };
}
